import { render, staticRenderFns } from "./picker-wxapp.vue?vue&type=template&id=6443562a&"
import script from "./picker-wxapp.vue?vue&type=script&lang=js&"
export * from "./picker-wxapp.vue?vue&type=script&lang=js&"
import style0 from "./picker-wxapp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports